import { useGraphneAPI } from '@nexelem/graphne-api';
import { useQuery } from '@tanstack/react-query';
import { useGanttSimulationTaskStateStore } from '../../Gantt/store';
import { useEffect } from 'react';

export const simulationMetaQueryKey = (simulationId: string) => ['simulation-meta', simulationId];

export const useSimulationMeta = (simulationId: string) => {
  const api = useGraphneAPI();
  const setFrozenTaskIds = useGanttSimulationTaskStateStore((state) => state.setFrozenTaskIds);
  const setTaskToPublishIds = useGanttSimulationTaskStateStore((state) => state.setTaskToPublishIds);

  const data = useQuery({
    queryKey: simulationMetaQueryKey(simulationId),
    queryFn: () => api.getGraphneSimulationSimulationidMetadata({ simulationId }),
    enabled: !!Number(simulationId),
    staleTime: Infinity,
  });

  useEffect(() => {
    const frozenTaskIds = data.data?.frozenTasks ?? [];
    setFrozenTaskIds(frozenTaskIds);
  }, [data.data?.frozenTasks, setFrozenTaskIds]);

  useEffect(() => {
    const tasksToPublishIds = data.data?.tasksToPublish ?? [];
    setTaskToPublishIds(tasksToPublishIds);
  }, [data.data?.tasksToPublish, setTaskToPublishIds]);

  return data;
};
